import React, { PureComponent } from 'react';
import { Modal, Form, Input, Button, message } from '@vadp/ui';
import { connect } from 'react-redux';
import { passwordCheck } from '../../utils/index';

const fromItemLayout1 = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
  },
};
class PasswordResetModal extends PureComponent {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
  };

  resetOk =() => {
    const { dispatch, form, initPwd, forceUpdatePwd, verifyPwdStrength } = this.props;
    const account = form.getFieldValue('uerName');
    const verifyCode = form.getFieldValue('sendPassword');
    const confirmPassword = form.getFieldValue('confirmPassword');
    const newPassword = form.getFieldValue('newPassword');
    const reg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9]{8,}$/;
    if (forceUpdatePwd && initPwd === newPassword) {
      message.warn('新密码不能与系统密码相同');
      return false;
    }
    // if (verifyPwdStrength && (!reg.test(newPassword))) {
    //   message.warn('密码长度不能少于8位,由大写字母小写字母数字组成');
    //   return false;
    // }

    dispatch({ type: 'resetPassword/savePassword', payload: { account, verifyCode, confirmPassword, newPassword } });
  }
  checkPassword = (newPassword)=> {
    let value = newPassword;
    console.log(value)
    let formData=[];
    let obj ={};
    let msg =''
    const {
      passwordLength,
      passwordMetacharacters,
      passwordCaseFlag,
      passwordStrongFlag,
    } = this.props;
    obj.passwordLength=passwordLength;
    obj.passwordMetacharacters=passwordMetacharacters;
    obj.passwordCaseFlag=passwordCaseFlag;
    obj.passwordStrongFlag=passwordStrongFlag;
    formData.push(obj);
    msg = passwordCheck(formData,value);
    if(msg!=''){
      message.info(msg);
      return false
    }else{
      return true
    }
  }
  resetCancel =() => {
    const { dispatch, form } = this.props;
    form.resetFields();
    dispatch({ type: 'resetPassword/updateReset', payload: { resetVisible: false } });
    dispatch({ type: 'resetPassword/updateBottonDisabled', payload: { btnDisabled: false } });
  }

  sendCodeClick=() => {
    const { dispatch, form, flag } = this.props;
    const account = form.getFieldValue('uerName');
    const captcha = form.getFieldValue('imgCode');
    if (typeof (account) === 'undefined') {
      message.info('用户名不能为空');
      return false;
    }
    if (typeof (captcha) === 'undefined') {
      message.info('图形验证码不能为空');
      return false;
    }
    dispatch({ type: 'resetPassword/sendCode', payload: { account, captcha, flag } });
  }
  confirmPasswordFun=(e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }
  compareToFirstPassword=(rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('newPassword')) {
      callback('两次输入密码不一样!');
    } else {
      callback();
    }
  }

  validateToNextPassword=(rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirmPassword'], { force: true });
    }
    callback();
  }

  componentDidMount() {
    this.props.form.resetFields();
  }

  componentWillUnmount() {
    this.props.form.resetFields();
  }
  changeValue = () => {
    const { dispatch } = this.props;
    dispatch({ type: 'resetPassword/getCodeImage', payload: { } });
  }
  render() {
    const { visible, form, btnDisabled, btnTitle, codeImage } = this.props;
    const { getFieldDecorator } = form;
    return (<div>
      <Modal
        width={450}
        title="重置密码"
        visible={visible}
        cancelText="取消"
        okText="保存"
        onOk={this.resetOk}
        onCancel={this.resetCancel}
        destroyOnClose
        maskClosable={false}
      >
        <Form >
          <Form.Item label="用户名" {...fromItemLayout1} >
            {getFieldDecorator('uerName', {
              rules: [{
                required: true,
                message: '请输入用户名!',
              }],
            })(
              <Input />,
              )}
          </Form.Item>
          <Form.Item label="图形验证码" {...fromItemLayout1} >
            {getFieldDecorator('imgCode', {
              rules: [{
                required: true,
                message: '请输入图形验证码！',
              }],
            })(
              <Input
                maxLength={5}
                suffix={
                  <div >
                    <img
                      src={codeImage} style={{ width: '100px',
                        height: '35px',
                        position: 'absolute',
                        right: '-11px',
                        top: '-17px',
                        borderRadius: '4px' }} onClick={this.changeValue}
                    />
                  </div>
                }
                placeholder="请输入校验码"
              />,
            )
            }
          </Form.Item>

          <Form.Item label="验证码" {...fromItemLayout1} >
            <div>
              <div style={{ display: 'inline-flex' }} >
                {getFieldDecorator('sendPassword', {
                  rules: [{
                    required: true,
                    message: '请输入验证码!',
                  }],
                },
                )(<Input style={{ marginRight: '15px' }} />)}
                <Button disabled={btnDisabled} onClick={this.sendCodeClick}>{btnTitle}</Button>
              </div>
            </div>
          </Form.Item>
          <Form.Item label="新密码" {...fromItemLayout1}>
            {getFieldDecorator('newPassword', {
              rules: [{
                required: true,
                message: '请输入新密码!',
              }, {
                validator: this.validateToNextPassword,
              }],
            },
            )(<Input type="password" />)}
          </Form.Item>
          <Form.Item label="密码确认" {...fromItemLayout1}>
            {getFieldDecorator(
              'confirmPassword',
              {
                rules: [{
                  required: true,
                  message: '请再次输入新密码!',
                },
                {
                  validator: this.compareToFirstPassword,
                },
                ],
              },
            )(<Input
              type="password"
              onBlur={this.confirmPasswordFun}
            />)}
          </Form.Item>

        </Form>
      </Modal>
    </div>

    );
  }

}
function mapStateToProps(state) {
  return {
    initPwd: state.resetPassword.initPwd,
    forceUpdatePwd: state.resetPassword.forceUpdatePwd,
    verifyPwdStrength: state.resetPassword.verifyPwdStrength,
    btnDisabled: state.resetPassword.btnDisabled,
    btnTitle: state.resetPassword.btnTitle,
    codeImage: state.resetPassword.codeImage,
    flag: state.resetPassword.flag,
    passwordLength: state.resetPassword.passwordLength,
    passwordMetacharacters: state.resetPassword.passwordMetacharacters,
    passwordCaseFlag: state.resetPassword.passwordCaseFlag,
    passwordStrongFlag: state.resetPassword.passwordStrongFlag,
  };
}
export default connect(mapStateToProps)(Form.create()(PasswordResetModal));



// WEBPACK FOOTER //
// ./src/components/PasswordReset/PasswordResetModal.js